import { render, staticRenderFns } from "./ReportColors.vue?vue&type=template&id=a45ca8ee"
import script from "./ReportColors.vue?vue&type=script&lang=js"
export * from "./ReportColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports